import { Injectable } from '@angular/core';
import { TotalCostsStateStore } from './total-costs.state';

@Injectable({
  providedIn: 'root'
})
export class TotalCostsService {

  constructor(private store: TotalCostsStateStore) { }

  addOrUpdatePartialCosts(partialCostsId: string, totalCosts?: number): void {
    this.store.update(state => {
      const partialCosts = state.partialCosts.find(s => s.id === partialCostsId);
      if (partialCosts) {
        partialCosts.totalCosts = totalCosts;
      } else {
        state.partialCosts.push({ id: partialCostsId, totalCosts });
      }
    });
  }

  removePartialCosts(partialCostsId: string): void {
    this.store.update(state => {
      const index = state.partialCosts.findIndex(s => s.id === partialCostsId);
      if (index !== -1) {
        state.partialCosts.splice(index, 1);
      }
    });
  }

  sectionInitialized(sectionId: string): void {
    this.store.update(state => {
      if (!state.initializedSections.find(s => s === sectionId)) {
        state.initializedSections.push(sectionId);
      }
    });
  }

  reset(): void {
    this.store.update(state => {
      state.partialCosts = [];
      state.initializedSections = [];
    });
  }
}
